import Box from '@mui/material/Box';

/**
 * Adds some spacing at the bottom of the page, so that the page can be scrolled a little bit
 * further to see the complete background image.
 */
export default function PageBottomSpacing() {
  return <Box sx={{paddingBottom: `${window.innerWidth / 16}px`}}/>;
}
